import React from 'react'
export default function particularclear() {
  return (
    <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.5 1L0.5 9" stroke="#202224" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M0.5 1L8.5 9" stroke="#202224" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

  )
}